module.exports = __webpack_public_path__ + "static/media/skull.e1040409.jpeg";